// extracted by mini-css-extract-plugin
module.exports = {"container":"_28Pepqr8ZJ1U93RKMzoaXx","switchActive":"_2zVUAZPiup3Bwj2UHLQtww","switchLabel":"_3jVe2-R82COYiwpu9hXc7W"};